<template>
  <v-footer>
    <v-row style="margin-left: 43px">
      <v-col cols="6" md="6" lg="3">
        <div class="d-flex">
          <img
            alt="filter"
            class="icons"
            src="@/assets/icons/dashboard/timer.svg"
          />
          <p class="footer-text pr-1 bold">{{ $t('DASHBOARD.FOOTER.AVERAGE_CUSTOMER') }}</p>
          <p class="footer-text">{{ $t('DASHBOARD.FOOTER.AVERAGE_RESPONSE') }}</p>
        </div>
      </v-col>
      <v-col cols="6" md="6" lg="2">
        <div class="d-flex">
          <img
            alt="filter"
            class="icons"
            src="@/assets/icons/dashboard/quality.svg"
          />
          <p class="footer-text pr-1">{{ $t('DASHBOARD.FOOTER.GUARANTEE') }}</p>
        </div>
      </v-col>
      <v-col cols="6" md="6" lg="2">
        <div class="d-flex">
          <img
            alt="filter"
            class="icons"
            src="@/assets/icons/dashboard/star.svg"
          />
          <div>
            <p class="footer-text bold">{{ $t('DASHBOARD.FOOTER.PRODUCT') }}</p>
            <p class="footer-text">{{ $t('DASHBOARD.FOOTER.CATEGORY') }}</p>
          </div>
        </div>
      </v-col>
      <v-col cols="6" md="6" lg="4" class="button">
        <v-btn
          variant="outlined"
          class="formation-button"
          :href="viteCalendlyUrl"
          target="_blank"
        >
          <p class="text-formation-button">{{ $t('DASHBOARD.FOOTER.BUTTON') }}</p>
        </v-btn>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'FooterInfo',
  data() {
    return {
      viteCalendlyUrl: import.meta.env.VITE_CALENDLY_URL,
      viteZendeskUrlNews: import.meta.env.VITE_ZENDESK_URL_NEWS
    }
  }
}
</script>

<style scoped>
.footer-text {
  color: black;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.bold {
  font-weight: 700;
}

.underline {
  text-decoration: underline;
  cursor: pointer;
}

.icons {
  margin-right: 15px;
}

.formation-button {
  display: flex;
  width: 362px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 15px;
  border-radius: 20px;
  border: unset;
  background: #559A1B;
  text-transform: unset !important;

}

.text-formation-button {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media screen and (min-width: 1280px) {
  .button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
